import { render, staticRenderFns } from "./fancyEditTable.vue?vue&type=template&id=1517b297&scoped=true"
import script from "./fancyEditTable.vue?vue&type=script&lang=js"
export * from "./fancyEditTable.vue?vue&type=script&lang=js"
import style0 from "./fancyEditTable.vue?vue&type=style&index=0&id=1517b297&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1517b297",
  null
  
)

component.options.__file = "fancyEditTable.vue"
export default component.exports